import { GetTeamSubscriptionMetricsAppsSummaryAverageWholeTeamQuery } from '../../../../../src/interface/queries/team-metrics/subscription/get-team-subscription-metrics-apps-summary-average-whole-team.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamSubscriptionMetricsAppsSummaryAverageWholeTeamAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/subscription/team-subscription-metrics-app-summary-average-whole-team.aggregate-root.mapper';
import { GetTeamSubscriptionMetricsAppsSummaryAverageWholeTeamRequestDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary-average-whole-team.request.dto';
import { GetTeamSubscriptionMetricsAppsSummaryResponseDto } from '../../../../../src/interface/dtos/team-metrics/subscription/get-team-subscription-metrics-apps-summary.response.dto';

export class GetTeamSubscriptionMetricsAppsSummaryAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamSubscriptionMetricsAppsSummaryAverageWholeTeamQuery,
    protected readonly mapper: TeamSubscriptionMetricsAppsSummaryAverageWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetTeamSubscriptionMetricsAppsSummaryAverageWholeTeamRequestDto
  ): Promise<GetTeamSubscriptionMetricsAppsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `TeamSubscriptionMetricsAppsSummaryAverageWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
